import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PaymentPeriod } from 'src/types/tax';

export interface DashboardState {
  isGetUsersTaxableLicensesInProgress: boolean;
  isGetUsersTaxableLicensesSuccess: boolean;
  usersTaxableLicenses: PaymentPeriod[];
  usersTaxableLicensesErrorMsg: string;
}

const INITIAL_STATE: DashboardState = {
  isGetUsersTaxableLicensesInProgress: false,
  isGetUsersTaxableLicensesSuccess: false,
  usersTaxableLicenses: [],
  usersTaxableLicensesErrorMsg: '',
};

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: INITIAL_STATE,
  reducers: {
    usersTaxableLicensesStarted: (state) => {
      state.isGetUsersTaxableLicensesInProgress = true;
      state.isGetUsersTaxableLicensesSuccess = false;
      state.usersTaxableLicensesErrorMsg = '';
    },
    usersTaxableLicensesSucceeded: (
      state,
      action: PayloadAction<PaymentPeriod[]>
    ) => {
      state.isGetUsersTaxableLicensesInProgress = false;
      state.isGetUsersTaxableLicensesSuccess = true;
      state.usersTaxableLicenses = action.payload;
      state.usersTaxableLicensesErrorMsg = '';
    },
    usersTaxableLicensesFailure: (state, action: PayloadAction<string>) => {
      state.isGetUsersTaxableLicensesInProgress = false;
      state.isGetUsersTaxableLicensesSuccess = false;
      state.usersTaxableLicenses = [];
      state.usersTaxableLicensesErrorMsg = action.payload;
    },

    resetDashboardState: () => INITIAL_STATE,
  },
});

export const {
  usersTaxableLicensesStarted,
  usersTaxableLicensesSucceeded,
  usersTaxableLicensesFailure,
  resetDashboardState,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
